/** Preislisten. Bezeichnungen kommen aus den Übersetzungen (labelKey),
 *  Preise werden im Admin unter "Preise" gepflegt, Bilder und Hinweise unter "Seiten → Preise". */
export interface PriceItem {
  labelKey: string;
  price: string;
  noteKey: string | null;
  highlight?: boolean;
  isSubItem?: boolean;
  isGroupHeader?: boolean;
}

export interface PriceSection {
  id: string;
  number: string;
  titleKey: string;
  subtitleKey: string | null;
  items: PriceItem[];
}

export interface PriceCategory {
  id: string;
  titleKey: string;
  subtitleKey: string;
  image: string;
  features?: string[];
  priceHeader?: string;
  legalNote?: string[];
  sections: PriceSection[];
}

export const PRICE_CATEGORIES: PriceCategory[] = [
  {
    id: "finanzbuchhaltung",
    titleKey: "preise.category_finanz_title",
    subtitleKey: "preise.category_finanz_subtitle",
    image: "/new_images/AdobeStock_87062828.webp",
    priceHeader: "Mindesthonorar / Honorar *",
    legalNote: [
      "Die genannten Mindesthonorare / Honorare stellen keine dauerhaft feststehenden Endpreise dar.",
      "Die Höhe und Angemessenheit der Vergütung wird regelmäßig, spätestens jedoch alle sechs Monate, überprüft und gegebenenfalls an den tatsächlichen Bearbeitungsaufwand, die Anzahl der Buchungen sowie die jeweiligen Gegenstandswerte angepasst.",
      "*) Alle Preise verstehen sich gegebenenfalls zuzüglich Auslagenersatz (Kosten) und gesetzlicher Umsatzsteuer.",
      "Wir erbringen unsere Leistungen im Rahmen des § 6 Nr. 3 und 4 StBerG.",
      "Stand: Januar 2026",
    ],
    sections: [
      {
        id: 'finanz_all',
        number: '',
        titleKey: 'preise.finanz_section_title',
        subtitleKey: null,
        items: [
          { labelKey: 'preise.finanz_s1_i1', price: '150,00 € / Monat', noteKey: null },
          { labelKey: 'preise.finanz_s1_i2', price: '250,00 € / Monat', noteKey: null },
          { labelKey: 'preise.finanz_s1_i3', price: '350,00 € / Monat', noteKey: null },
          { labelKey: 'preise.finanz_s1_i4', price: '350,00 € / Monat', noteKey: null },
          { labelKey: 'preise.finanz_s1_i5', price: '450,00 € / Monat', noteKey: null },
          { labelKey: 'preise.finanz_s1_i6', price: '180,00 € / Monat', noteKey: null },
          { labelKey: 'preise.finanz_s1_i7', price: '300,00 € / Quartal', noteKey: null },
          { labelKey: 'preise.finanz_s2_title', price: '110,00 € / Std.', noteKey: null, isGroupHeader: true },
          { labelKey: 'preise.finanz_s2_i1', price: '', noteKey: null, isSubItem: true },
          { labelKey: 'preise.finanz_s2_i2', price: '', noteKey: null, isSubItem: true },
        ],
      },
    ],
  },
  {
    id: "lohnbuchhaltung",
    titleKey: "preise.category_lohn_title",
    subtitleKey: "preise.category_lohn_subtitle",
    image: "/new_images/AdobeStock_178589265.webp",
    legalNote: [
      '*) Alle Preise verstehen sich gegebenenfalls zuzüglich Auslagenersatz (Kosten) und gesetzlicher Umsatzsteuer.',
      'Wir erbringen unsere Leistungen im Rahmen des § 6 Nr. 3 und 4 StBerG.',
    ],
    sections: [
      {
        id: "einrichtung",
        number: "1",
        titleKey: "preise.lohn_s1_title",
        subtitleKey: null,
        items: [
          {
            labelKey: "preise.lohn_s1_i1",
            price: "79,90 €",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s1_i2",
            price: "239,00 €",
            noteKey: "preise.lohn_note_net",
          },
        ],
      },
      {
        id: "abrechnung",
        number: "2",
        titleKey: "preise.lohn_s2_title",
        subtitleKey: "preise.lohn_s2_sub",
        items: [
          {
            labelKey: "preise.lohn_s2_i1",
            price: "20,00 €",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s2_i2",
            price: "19,00 €",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s2_i3",
            price: "17,00 €",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s2_i4",
            price: "27,00 €",
            noteKey: "preise.lohn_note_net",
            highlight: true,
          },
          {
            labelKey: "preise.lohn_s2_i5",
            price: "25,00 €",
            noteKey: "preise.lohn_note_net",
            highlight: true,
          },
          {
            labelKey: "preise.lohn_s2_i6",
            price: "23,00 €",
            noteKey: "preise.lohn_note_net",
            highlight: true,
          },
          {
            labelKey: "preise.lohn_s2_i7",
            price: "20,00 €",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s2_i8",
            price: "12,90 €",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s2_i9",
            price: "19,90 €",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s2_i10",
            price: "5,00 €",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s2_i11",
            price: "15,00 €",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s2_i12",
            price: "40,00 €",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s2_i13",
            price: "9,50 €",
            noteKey: "preise.lohn_note_net",
          },
        ],
      },
      {
        id: "bescheinigungen",
        number: "3",
        titleKey: "preise.lohn_s3_title",
        subtitleKey: null,
        items: [
          {
            labelKey: "preise.lohn_s3_i1",
            price: "32,00 €",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s3_i2",
            price: "32,00 €",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s3_i3",
            price: "9,90 €",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s3_i4",
            price: "49,90 €",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s3_i5",
            price: "49,90 €",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s3_i6",
            price: "65,00 €",
            noteKey: "preise.lohn_note_net",
          },
        ],
      },
      {
        id: "antraege",
        number: "4",
        titleKey: "preise.lohn_s4_title",
        subtitleKey: null,
        items: [
          { labelKey: "preise.lohn_s4_i1", price: "16,50 €", noteKey: null },
          {
            labelKey: "preise.lohn_s4_i2",
            price: "100,00 € / Std.",
            noteKey: "preise.lohn_note_net",
          },
        ],
      },
      {
        id: "nebenleistungen",
        number: "5",
        titleKey: "preise.lohn_s5_title",
        subtitleKey: null,
        items: [
          {
            labelKey: "preise.lohn_s5_i1",
            price: "74,90 €",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s5_i2",
            price: "74,90 €",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s5_i3",
            price: "25,00 € / ¼ Std.",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s5_i4",
            price: "9,90 €",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s5_i5",
            price: "19,90 €",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s5_i6",
            price: "39,90 €",
            noteKey: "preise.lohn_note_net",
          },
        ],
      },
      {
        id: "beratungen",
        number: "6",
        titleKey: "preise.lohn_s6_title",
        subtitleKey: null,
        items: [
          {
            labelKey: "preise.lohn_s6_i1",
            price: "100,00 € / Std.",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s6_i2",
            price: "100,00 € / Std.",
            noteKey: "preise.lohn_note_net",
          },
          {
            labelKey: "preise.lohn_s6_i3",
            price: "100,00 € / Std.",
            noteKey: "preise.lohn_note_net",
          },
        ],
      },
    ],
  },
];

// Legacy exports kept for PriceDetailPage compatibility
export const PRICE_DATA: PriceSection[] = PRICE_CATEGORIES.find(
  (c) => c.id === "lohnbuchhaltung",
)!.sections;
export const SECTION_IMAGES: Record<string, string> = {
  einrichtung: "/new_images/AdobeStock_219806190.webp",
  abrechnung: "/new_images/AdobeStock_267386573.webp",
  bescheinigungen: "/new_images/AdobeStock_334106203.webp",
  antraege: "/new_images/AdobeStock_358947058.webp",
  nebenleistungen: "/new_images/AdobeStock_1082462942.webp",
  beratungen: "/new_images/AdobeStock_302630798.webp",
};

export const PREISE_KEY = 'page_preise';

export interface PriceCategoryContent { image: string; price_header: string; legal_note: string; }

export const PREISE_DEFAULTS: { categories: Record<string, PriceCategoryContent> } = {
  categories: Object.fromEntries(
    PRICE_CATEGORIES.map((c) => [
      c.id,
      { image: c.image, price_header: c.priceHeader ?? '', legal_note: (c.legalNote ?? []).join('\n') },
    ]),
  ),
};

/** Übernimmt Bild, Preisüberschrift und Hinweise aus dem Admin in eine Kategorie */
export function applyCategoryContent(
  category: PriceCategory,
  content: typeof PREISE_DEFAULTS,
): PriceCategory {
  const c = content.categories[category.id];
  if (!c) return category;
  return {
    ...category,
    image: c.image || category.image,
    priceHeader: c.price_header || undefined,
    legalNote: c.legal_note ? c.legal_note.split('\n').filter((l) => l.trim() !== '') : undefined,
  };
}
